// Recursively sort object keys so JSON serialization is stable regardless of
// insertion order. Arrays preserve their element order.
function canonicalize(value) {
    if (value === null || typeof value !== 'object')
        return value;
    if (Array.isArray(value))
        return value.map(canonicalize);
    return Object.keys(value)
        .sort()
        .reduce((acc, key) => {
        acc[key] = canonicalize(value[key]);
        return acc;
    }, {});
}
/**
 * Compute a stable SHA-256 hash of a CharacterDefinition.
 * Uses the Web Crypto API so it works in both browser and Node.js 22+.
 * The hash is identical to what the server previously computed server-side —
 * same canonicalization, same algorithm.
 */
export async function hashDefinition(definition) {
    const canonical = JSON.stringify(canonicalize(definition));
    const data = new TextEncoder().encode(canonical);
    const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
